import { render } from "./ScreenShot.vue?vue&type=template&id=2e5f5f7b&scoped=true"
import script from "./ScreenShot.vue?vue&type=script&lang=js"
export * from "./ScreenShot.vue?vue&type=script&lang=js"

import "./ScreenShot.vue?vue&type=style&index=0&id=2e5f5f7b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5f5f7b"]])

export default __exports__